import SalesAdvertisingMonthlyReportPage from './SalesAdvertisingMonthlyReportPage';

export default SalesAdvertisingMonthlyReportPage;
